import { Toaster } from "../sonner";
import type { ToastPosition } from "./types";
import { DEFAULT_POSITION } from "./types";

const POSITION_MAP: Record<
  ToastPosition,
  | "top-left"
  | "top-center"
  | "top-right"
  | "bottom-left"
  | "bottom-center"
  | "bottom-right"
> = {
  "top-left": "top-left",
  "top-center": "top-center",
  "top-right": "top-right",
  "bottom-left": "bottom-left",
  "bottom-center": "bottom-center",
  "bottom-right": "bottom-right",
};

interface ToastProviderProps {
  children: React.ReactNode;
  position?: ToastPosition;
  maxVisible?: number;
}

export function ToastProvider({
  children,
  position = DEFAULT_POSITION,
  maxVisible = 3,
}: ToastProviderProps) {
  return (
    <>
      {children}
      <Toaster
        position={POSITION_MAP[position]}
        visibleToasts={maxVisible}
        closeButton
        richColors
      />
    </>
  );
}
